import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { Invdetail } from 'src/app/shared/models/Invdetail';
import { LstStoreResponse } from 'src/app/shared/models/lstStoreResponse';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { Store } from 'src/app/shared/models/Store';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';

@Component({
  selector: 'app-invdet-adjustment',
  templateUrl: './invdet-adjustment.component.html',
  styleUrls: ['./invdet-adjustment.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class InvdetAdjustmentComponent implements OnInit {
  lbl_select: string = "select_";
  lbl_zone: string = "zone_";
  lbl_natio: string = "national_";
  lbl_search: string = "search_";
  lbl_total: string = "total_";
  lbl_there_are: string = "there_are_";

  listInvItems: Invdetail[];
  listZones: Store[];
  selectedZone: Store;
  listNatio: Store[];
  selectedNatio: Store;
  listStores: string[] = [];
  token: string;
  security: SecurityDocument;
  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService
  ) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
        });
    this.getSecurity();
  }
  getSecurity() {
    this.listZones = [];
    this.listNatio = [];

    this.apiService.findSecurityById(
      {
        "id": this.token
      }
    ).then(
      data => {
        this.security = data;
        if (this.security.levelId == 'N') {
          //this.selectedNatio = this.security.storeId;
          //this.selectedZone = this.security.strZone;
          this.listZones.push(this.selectedZone);
          this.listNatio.push(this.selectedNatio);

        } if (this.security.levelId == 'Z') {
          //this.selectedZone = this.security.strZone;
          this.listZones.push(this.selectedZone);
          this.getChildStores(this.selectedZone.storeId, 'N');
        } else {
          this.getChildStores('0000000002', 'Z');
        }



        this.getTranslatedLabels();
        this.getValidStores();


      });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields(
      {
        'language': this.security.language,
        'region': this.security.region,
        'lstLabels': [this.lbl_select, this.lbl_zone, this.lbl_natio, this.lbl_search, this.lbl_total, this.lbl_there_are]
      }
    ).then(
      trDocs => {
        lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_zone = map.get(this.lbl_zone);
        this.lbl_natio = map.get(this.lbl_natio);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_there_are = map.get(this.lbl_there_are);
      });
  }
  getValidStores() {
    let lstRes: LstStoreResponse;
    let supStoreId: string;
    if (this.selectedNatio != null && this.selectedNatio.storeId != null) {
      supStoreId = this.selectedNatio.storeId;
    } else if (this.selectedZone != null && this.selectedZone.storeId != null) {
      supStoreId = this.selectedZone.storeId;
    } else {
      supStoreId = "0000000002";
    }
    this.apiService.getDependetLocalStores(
      {
        "year": "",
        "period": "",
        "storeId": supStoreId
      }
    ).then(
      data => {
        this.listStores = data;

      });
  }
  getChildStores(selStr: string, level: string) {
    let res: LstStoreResponse;
    this.apiService.getListStore(selStr, "", "").then(
      data => {
        res = data;
        if (level == 'N') {
          this.listNatio = res.lstStore;
        } else if (level == 'Z') {
          if (this.listZones == null || this.listZones.length == 0) {
            this.listZones = res.lstStore;
          }
        }
      });

  }
  loadNatios(event) {
    if (this.selectedZone != null && this.selectedZone.storeId != null) {
      this.getChildStores(this.selectedZone.storeId, 'N');
    }
  }
  loadCountrys(event) {

    if (this.selectedNatio != null && this.selectedNatio.storeId != null) {

    }
  }
  search() {
  }



  exportExcel() {
    if (this.listInvItems === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.listInvItems.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.listInvItems.map((item) => {
        return {
          "ID_ARTICULO": item.id || 'S/N',
          "CANTIDAD": item.qty || 'S/N',
          "COSTO_PROMEDIO": item.avgCost || 'S/N'
        };
      });


      this.filesService.tovpilExportXLSX(filteredJSON, 'listInvdetAdjustment_');

    }
  }



  exportPdf() {
    if (this.listInvItems === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.listInvItems.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.listInvItems.map((item) => {
        return {
          "ID_ARTICULO": item.id || 'S/N',
          "CANTIDAD": item.qty || 'S/N',
          "COSTO_PROMEDIO": item.avgCost || 'S/N'
        };
      });



      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listInvdetAdjustment_');

    }
  }


}
